import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import AdditionalInformation from "../../components/additional-information"
import ContentTransformer from "../../components/Transformers/content-transformer"
import {
  pageIntro,
  pageBody,
  pageIntroContainer,
  pageIntroTaxoContainer,
  pageIntroTitle,
  pageIntroImg,
  pageIntroImgFull,
  pageAdditionalInfos,
  pageFooter,
  pageFooterBack,
  pageTaxo,
  editButton,
} from "./styles/detailsPage.module.scss"
import PropTypes from "prop-types"
import {
  AdditionalInfos,
  PageFooterContainer,
  PageIntroContainer,
  PageIntroTitle,
  PageTaxo,
} from "./styled-components/page-styled"
import TransitionFade from "../../components/transition-fade"
import FadeIn from "react-fade-in"
import Ariane from "../../components/Ariane/ariane"
import SocialPanel from "../../components/SocialMedias/social-panel"
import EditButton from "../../components/EditButton/edit-button"
import { LightBoxImage } from "../../components/LightBoxImage/light-box-image"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodePage(path: { alias: { eq: $slug } }) {
      ...PageItem
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const PageTemplate = ({ data, location }) => {
  const page = data.nodePage
  return (
    <Layout isDetail={true}>
      <SEO
        title={page.title}
        description={
          "Dans cette page, vous découvrez le contenu suivant : " + page.title
        }
        nodeImageUrl={
          page.relationships?.field_image_page_de_base?.localFile
            ?.SlugifiedPublicUrl
        }
      />
      <Ariane isDetail={true} postName={page.title} />
      <FadeIn delay={150}>
        <PageIntroContainer className={pageIntro}>
          <PageIntro page={page} />
        </PageIntroContainer>
        <section className={pageBody}>
          <ContentTransformer content={page.body?.processed} />
          <PageFooter location={location.href} page={page} />
        </section>
        <PageInfos page={page} />
      </FadeIn>
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component/Intro---------------------------//

const PageIntro = ({ page }) => {
  return (
    <>
      <div className={pageIntroContainer}>
        {page.relationships?.field_taxonomie_thematique?.length > 0 && (
          <div className={pageIntroTaxoContainer}>
            {page.relationships.field_taxonomie_thematique.map(
              (taxo, index) => (
                <TransitionFade key={index} link={taxo.path.alias}>
                  <PageTaxo key={taxo.name} className={pageTaxo}>
                    {taxo.name}
                  </PageTaxo>
                </TransitionFade>
              )
            )}
          </div>
        )}
        <PageIntroTitle className={pageIntroTitle}>
          <EditButton
            link={"/node/" + page.drupal_internal__nid + "/edit"}
            addedClass={editButton}
          />
          {page.title}
        </PageIntroTitle>
        {page.body?.summary && (
          <p
            dangerouslySetInnerHTML={{
              __html: page.body.summary,
            }}
          />
        )}
      </div>
      <div className={page.body?.summary ? pageIntroImgFull : pageIntroImg}>
        {page.relationships?.field_image_page_de_base?.localFile && (
          <LightBoxImage
            type={"node"}
            node={{
              alt: page.relationships.field_image_page_de_base.alt,
              file: page.relationships.field_image_page_de_base.localFile,
            }}
          />
        )}
      </div>
    </>
  )
}

//-----------------------Child component/Intro---------------------------//

//-----------------------Child component/Footer---------------------------//

const PageFooter = ({ page, location }) => (
  <PageFooterContainer className={pageFooter}>
    <div className={pageFooterBack}>
      <TransitionFade arialabel="Retour à l'accueil" link="/">
        Retour à l&apos;accueil
      </TransitionFade>
    </div>
    <SocialPanel location={location} postData={page} />
  </PageFooterContainer>
)

//-----------------------Child component/Footer---------------------------//

//-----------------------Child component/Infos---------------------------//

const PageInfos = ({ page }) => (
  <>
    {page.field_infos_complementaires && (
      <AdditionalInfos className={pageAdditionalInfos}>
        <AdditionalInformation node={page} />
      </AdditionalInfos>
    )}
  </>
)

//-----------------------Child component/Infos---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Styled component---------------------------//

//-----------------------Prop-Types---------------------------//

PageTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
PageInfos.propTypes = {
  page: PropTypes.object.isRequired,
}
PageIntro.propTypes = {
  page: PropTypes.object.isRequired,
}
PageFooter.propTypes = {
  page: PropTypes.object.isRequired,
  location: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default PageTemplate
